import { userSessionStore } from '../user-session-store'

function userIsLoggedIn() {
  const session = userSessionStore.readUserSession()
  return !!session?.email
}

export { userIsLoggedIn }